/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Clips_CarriageInputs */

const en_road_dude_clips_carriage = /** @type {(inputs: Road_Dude_Clips_CarriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The ornate carriage`)
};

const zh_road_dude_clips_carriage = /** @type {(inputs: Road_Dude_Clips_CarriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复古马车翻拍`)
};

/**
* | output |
* | --- |
* | "The ornate carriage" |
*
* @param {Road_Dude_Clips_CarriageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_clips_carriage = /** @type {((inputs?: Road_Dude_Clips_CarriageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Clips_CarriageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_clips_carriage(inputs)
	return zh_road_dude_clips_carriage(inputs)
});
export { road_dude_clips_carriage as "road_dude.clips.carriage" }